/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import { cancelCustomerRecurringBooking } from 'school-space-client/api';
import { Button, ModalContext } from 'school-space-client/components';

import css from './css';

const RecurringBookingCardActionButtons = ({ booking, onUpdate, history }) => {
    const {
        openModal,
        closeModal,
        types: { cancellation }
    } = useContext(ModalContext);

    const { id, stateId } = booking;
    const goToBookingPage = () => history.push(`/repeat-bookings/${id}`);

    const openCancellationModal = () =>
        openModal({
            type: cancellation,
            props: {
                title: 'Are you sure you do not want this repeat booking?',
                cancellationType: 'customerRebooking',
                message: () => <p>Your spaces will be available for other customers to book.</p>,
                confirmText: 'Yes, cancel repeat booking',
                cancelText: 'No, keep booking',
                confirmAction: cancellationReason =>
                    cancelCustomerRecurringBooking(
                        booking.customer.id,
                        booking.id,
                        cancellationReason
                    )
                        .then(onUpdate)
                        .then(closeModal)
            }
        });

    const ManageButton = () => (
        <Button styles={css.actionButton} state="ghost" size="small" onClick={goToBookingPage}>
            Manage repeat booking
        </Button>
    );

    const ReviewButton = () => (
        <Button styles={css.actionButton} size="small" onClick={goToBookingPage}>
            Review booking
        </Button>
    );

    const CancelButton = () => (
        <Button
            styles={css.actionButton}
            state="ghost-warning"
            size="small"
            onClick={openCancellationModal}
        >
            I don&apos;t want this booking
        </Button>
    );

    switch (stateId) {
        case 'prospective':
            return (
                <div css={css.buttonContainer}>
                    <CancelButton />
                    <ReviewButton />
                </div>
            );
        default:
            return (
                <div css={css.buttonContainer}>
                    <ManageButton />
                </div>
            );
    }
};

RecurringBookingCardActionButtons.propTypes = {
    booking: PropTypes.objectOf(PropTypes.any).isRequired,
    onUpdate: PropTypes.func.isRequired,
    history: ReactRouterPropTypes.history.isRequired
};

export default withRouter(RecurringBookingCardActionButtons);
